module.exports = __webpack_public_path__ + "static/media/alliedGlobal-03.663f2475.png";